/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import sass from "./objects.module.sass";
import { ReactComponent as ActionMenuIcon } from "images/ActionMenuIcon.svg";
import { CreateContext } from "pages/StepPages/StepFour/One/Tables/Tables";
import PortalWrapper from "components-new/PortalWrapper";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { Button } from "components/shared";
import ObjectOfImpactModal from "pages/StepPages/StepFour/One/Tables/TableNavigate/ObjectsOfImpactTable/ObjectOfImpactModal";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import DropMenu from "pages/StepPages/StepFour/One/Tables/TableNavigate/DropMenu";
import { fetchObjectOfImpactTableData } from "pages/StepPages/StepFour/One/Tables/fetch";
import { useParams } from "react-router-dom";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import parentSass from "pages/StepPages/StepFour/One/Tables/TableNavigate/nav.module.sass";
import { useAnimate } from "components-new/AnimateTemp/AnimateTemp";
import { snackWrapper } from "helpers";
import { ChangeActiveTabContext } from "../TableNavigate";
import { organizationAPI } from "libs/apiClient/Organization";
import { InfluenceObjectResponse } from "libs/apiClient/data-contracts";

interface IModal {
	data: InfluenceObjectResponse | null;
	active: null | "create" | "edit";
}

interface IRow {
	modal: (any: any) => void;
	data: any;
	index: number;
	setData: (id: number) => void;
}

const riskType = {
	FIRST: "У1",
	SECOND: "У2",
	THIRD: "У3",
};

const Row: React.FC<IRow> = ({ modal, setData, data }) => {
	const { confirm, openConfirm } = useContext(CreateContext);
	const { updateTabs } = useContext(ChangeActiveTabContext);
	/**
	 * хранит элемент на который щелкнули, используется для отображения выпадающего меню для удаления строки таблицы
	 */
	const [target, setTarget] = useState<HTMLOrSVGElement | undefined>();
	const toggleTarget = (e: React.MouseEvent<HTMLOrSVGElement>) => {
		e.stopPropagation();
		target ? setTarget(undefined) : setTarget(e.currentTarget);
	};

	useOutsideAlerter(target, () => setTarget(undefined));

	// const {className,handleClose} = useAnimate({
	// unMount:data.fields.length > 0 ? sass.close_row:sass.close,
	// mount:data.fields.length > 0 ? sass.open_row:sass.open,
	// unMount:data.fields.length > 1?sass.open_row:sass.open,
	// mount:data.fields.length > 1? sass.close_row:sass.close,
	// delay:200,
	// firstUnMount:true
	// })

	/**
	 * удаление определенной строки
	 */
	const removeItem = () => {
		if (confirm) {
			openConfirm();
			return;
		}
		if (target) {
			organizationAPI.objectInfluenceDelete(Number(target.dataset.id)).then(() => {
				snackWrapper("success", "Запись успешно удалена");
				updateTabs("INFLUENCE");
				setData(Number(target.dataset.id));
			});
		}
	};
	return (
		<>
			{/*<tr className={className} onClick={()=> {*/}
			<tr
				className={sass.open}
				onClick={() => {
					confirm
						? openConfirm()
						: modal({
								data: {
									influence: data.fields[0].influence,
									id: data.fields[0].id,
									riskType: data.fields[0].riskType,
									type: data.fields[0].type,
									consequences: data.name,
								},
								active: "edit",
						  });
				}}>
				{/*<td rowSpan={data.fields.length}>*/}
				<td>
					<div>{data.fields[0].index}</div>
				</td>
				{/*<td rowSpan={data.fields.length}>*/}
				<td rowSpan={data.fields.length}>
					<div>
						{data.name} ({riskType[data.fields[0].riskType as keyof typeof riskType]})
					</div>
				</td>
				<td>
					<div>{data.fields[0].influence}</div>
				</td>
				<td>
					<div>{data.fields[0].type}</div>
				</td>
				<td>
					<div>
						<ActionMenuIcon data-id={data.fields[0].id} onClick={toggleTarget} />
					</div>
				</td>
			</tr>
			{data.fields.map((_: any, index: number) => {
				return index > 0 ? (
					<SubRow name={data.name} key={_.id} modal={modal} data={_} index={index + 1} setData={setData} />
				) : null;
			})}
			<DropMenu click={removeItem} target={target} />
		</>
	);
};
//eslint-disable-next-line
const SubRow: React.FC<IRow & { name: string }> = ({ modal, setData, name, data }) => {
	const { confirm, openConfirm } = useContext(CreateContext);
	const { updateTabs } = useContext(ChangeActiveTabContext);
	/**
	 * хранит элемент на который щелкнули, используется для отображения выпадающего меню для удаления строки таблицы
	 */
	const [target, setTarget] = useState<HTMLOrSVGElement | undefined>();
	const toggleTarget = (e: React.MouseEvent<HTMLOrSVGElement>) => {
		e.stopPropagation();
		target ? setTarget(undefined) : setTarget(e.currentTarget);
	};

	useOutsideAlerter(target, () => setTarget(undefined));

	const { className } = useAnimate({
		// unMount:parentSass.open,
		// mount:parentSass.close,
		unMount: sass.close,
		mount: sass.open,
		delay: 200,
		firstUnMount: true,
	});

	/**
	 * удаление определенной строки
	 */
	const removeItem = () => {
		if (confirm) {
			openConfirm();
			return;
		}
		if (target) {
			organizationAPI.objectInfluenceDelete(Number(target.dataset.id)).then(() => {
				snackWrapper("success", "Запись успешно удалена");
				updateTabs("INFLUENCE");
				setData(Number(target.dataset.id));
			});
		}
	};
	return (
		<>
			<tr
				className={className}
				onClick={() => {
					confirm
						? openConfirm()
						: modal({
								data: {
									influence: data.influence,
									id: data.id,
									riskType: data.riskType,
									type: data.type,
									consequences: name,
								},
								active: "edit",
						  });
				}}>
				<td>
					<div>{data.index}</div>
				</td>
				<td>
					<div>{data.influence}</div>
				</td>
				<td>
					<div>{data.type}</div>
				</td>
				<td>
					<div>
						<ActionMenuIcon data-id={data.id} onClick={toggleTarget} />
					</div>
				</td>
			</tr>
			<DropMenu click={removeItem} target={target} />
		</>
	);
};

const ObjectsOfImpactTable = () => {
	/**
	 * данные из контекста, контейнер для добавления элементов в шапку и данные для таблицы
	 */
	const { container, currentThread, confirm, openConfirm, selectFile, checkTables } = useContext(CreateContext);

	const [load, setLoad] = useState(false);

	// /**
	//  * хранит элемент на который щелкнули, используется для отображения выпадающего меню для удаления строки таблицы
	//  */
	// const [target,setTarget] = useState<HTMLOrSVGElement|undefined>()
	// const toggleTarget = (e: React.MouseEvent<HTMLOrSVGElement>) => {
	//     e.stopPropagation()
	//     target ? setTarget(undefined):setTarget(e.currentTarget)
	// };
	//
	// useOutsideAlerter(target,()=>setTarget(undefined))

	/**
	 * стэйт модалки для редактирования или создания данных для таблицы
	 */
	const [modal, setModal] = useState<IModal>({ data: null, active: null });

	/**
	 * данные таблицы
	 */
	const [objects, setObjects] = useState<InfluenceObjectResponse[]>([]);

	const params = useParams();

	useEffect(() => {
		setLoad(true);
		fetchObjectOfImpactTableData(Number(params.threadId))
			.then((objectOfImpact) => {
				setLoad(false);
				setObjects(objectOfImpact);
			})
			.catch(() => setLoad(false));
		//eslint-disable-next-line
	}, []);

	/**
	 * здесь идет переформатирования данных с сервера для объединения некоторых столбцов и строк по имени
	 */
	const render = useMemo(() => {
		const temp: { [key: string]: any } = {};
		objects
			.sort((a, b) => `${a.consequences}`.localeCompare(`${b.consequences}`))
			.forEach((_, index) => {
				if (temp[`${_.consequences}`]) {
					const { consequences, ...rest } = _;
					temp[`${_.consequences}`].push({ ...rest, index: index + 1 });
				} else {
					const { consequences, ...rest } = _;
					temp[`${_.consequences}`] = [{ ...rest, index: index + 1 }];
				}
			});
		let arrResult: { name: string; fields: { type: string; influence: string; id: number }[] }[] = [];
		let tempKey: any;
		for (tempKey in temp) {
			arrResult.push({
				name: tempKey,
				fields: temp[tempKey],
			});
		}
		return arrResult;
	}, [objects]);

	/**
	 * удаление определенной строки
	 */
	// const removeItem = () => {
	//     if (target) {
	//         $api.delete(`/organization/object/influence/${target.dataset.id}`)
	//             .then(()=> {
	//                 Snackbar({factor: 'light', title: 'Запись успешно удалена', type: 'success', delay: 3000})
	//                 setObjects([...objects].filter(_=>Number(target.dataset.id) !== _.id))
	//             })
	//             .catch(()=>Snackbar({factor:'light',title:'Что-то пошло не так ...',type:'error',delay:3000}));
	//     }
	// }
	const ref = useRef<HTMLInputElement>(null);

	return (
		<div className={sass.wrapper}>
			{/*<DropMenu click={removeItem} target={target}/>*/}
			<ObjectOfImpactModal
				toggle={modal.active}
				// options={render}
				data={objects}
				active={modal.data}
				close={() => setModal({ data: null, active: null })}
				replace={(newObjects) => {
					setObjects(newObjects);
				}}
			/>
			{container.current && (
				<PortalWrapper containerRef={container.current}>
					<input
						ref={ref}
						accept={".docx, application/pdf"}
						onChange={(e) => {
							selectFile(e);
						}}
						id={"file"}
						type={"file"}
						disabled={currentThread?.threatStatus === "APPROVED"}
						hidden={true}
					/>
					<Button
						onClick={() => {
							checkTables({
								type: "model",
								ok: () => {
									ref.current?.click();
								},
							});
						}}
						disabled={currentThread?.threatStatus === "APPROVED"}
						variant={BUTTON_VARIANTS.OUTLINED}>
						Загрузить утвержденный документ
					</Button>
					<Button
						variant={BUTTON_VARIANTS.CONTAINED}
						onClick={() => (confirm ? openConfirm() : setModal({ active: "create", data: null }))}>
						Добавить информацию
					</Button>
				</PortalWrapper>
			)}
			<div className={sass.sticky}>
				<div className={sass.caption}>Таблица 2 – Объекты воздействия и виды воздействия на них</div>
				<table>
					<thead>
						<tr>
							<th>№</th>
							<th>Негативные последствия</th>
							<th>Объекты воздействия</th>
							<th>Виды воздействия</th>
							<th />
						</tr>
					</thead>
				</table>
			</div>
			<div data-comment-false={true} className={sass.scroll}>
				{load ? (
					<LoadingIcon width={50} height={50} className={parentSass.loading} />
				) : (
					<table>
						<tbody>
							{render.map((_, index) => {
								return (
									<Row
										key={_.fields[0].id}
										modal={setModal}
										data={_}
										index={index + 1}
										setData={(num) => setObjects((prevState) => [...prevState].filter((_) => num !== _.id))}
									/>
								);
							})}
							{/*{objects.map((_, index) => {*/}
							{/*    return (*/}
							{/*        <Row key={_.id} modal={setModal} data={_} index={index + 1} setData={(num)=> setObjects(prevState => [...prevState].filter(_=>num!==_.id))}/>*/}
							{/*    );*/}
							{/*})}*/}
						</tbody>
					</table>
				)}
			</div>
		</div>
	);
};

export default ObjectsOfImpactTable;
